module.exports = __webpack_public_path__ + "static/media/s_4.87b7e2d6.mp3";